/* eslint-disable no-console */

// Events
import { MOUNT_COMPONENTS } from 'events';
// Lib
import PhillRecommendations from 'lib/PhillRecommendations';
import Tracking from 'lib/tracking';
import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import { hide } from 'utils/node';

export default component(async (node, ctx) => {
  const { title = [], swiperCarousel = [] } = choozy(node);

  let titles = [].concat(title);
  let swiperCarousels = [].concat(swiperCarousel);

  const recommendationsEngine = new PhillRecommendations({
    compilationTemplate: 'recommendation-products',
    sectionId: 'product-recommendations',
    itemQuery: '[data-recommendation-item]',
  });

  const { productObject } = node.dataset;
  const product = productObject ? JSON.parse(productObject) : null;

  let activeIndex;

  const toggleSlider = (index) => {
    if (index === activeIndex || index >= titles.length) return;

    activeIndex = index;

    [...swiperCarousels, ...titles].forEach((el) => el.classList.remove('show'));

    titles[index].classList.add('show');
    swiperCarousels[index].classList.add('show');

    swiperCarousels[index]?.swiper.slideTo(0, 0);

    Tracking.trackViewItemList({
      products: Array.from(swiperCarousels[index].querySelectorAll('[data-product-item]')).map(
        (item) => JSON.parse(item.dataset.productItem || '{}'),
      ),
      placement: 'recommendations',
    });
  };

  const init = async () => {
    const recommendationQueries = swiperCarousels.map((el) => [
      el.dataset.type,
      [{ ...product, variant_id: product.selected_or_first_available_variant.id }],
    ]);

    try {
      const results = await recommendationsEngine.query(...recommendationQueries);

      results.forEach((items, index) => {
        // Null means that the recommendation type is not supported in PhillRecommendations. For example when they add a static recommendations block
        if (items !== null) {
          if (items.length === 0) {
            hide(swiperCarousels[index], titles[index]);
          } else {
            swiperCarousels[index].dispatchEvent(
              new CustomEvent('replace-slides', { detail: { slides: items } }),
            );
          }
        }
      });
    } catch (err) {
      console.error(err);
    }

    titles = titles.filter((el) => !el.hidden);
    swiperCarousels = swiperCarousels.filter((el) => !el.hidden);

    if (titles.length === 0) {
      hide(node);
    } else {
      ctx.emit(MOUNT_COMPONENTS);

      toggleSlider(0);
    }

    if (titles.length > 1) {
      titles.forEach((el, index) => {
        el.addEventListener('click', () => toggleSlider(index));
      });

      swiperCarousels.forEach((el, index) => {
        const { swiper } = el;

        swiper.on('reachEnd', () => toggleSlider(index + 1 > swiperCarousels ? 0 : index + 1));
      });
    }
  };

  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.target === node) {
        init();
        observer.disconnect();
      }
    });
  });

  intersectionObserver.observe(node);
});
